import { FormField } from 'components/shared/form';

export const settingsAndExportFormFields: FormField[] = [
  {
    name: 'export',
    fields: [
      {
        name: 'sections',
        fields: [
          'propertyDetails',
          'residentialRentRoll',
          'residentialRentComps',
          'commercialRentRoll',
          'commercialRentComps',
          'expenseHistory',
          'expenseComps',
          'proForma',
          'capRateConclusion',
          'financingTerms',
        ].map((sectionId) => {
          return {
            name: sectionId,
            fields: [
              {
                name: 'enabled',
                bindings: 'Checkbox',
                value: true,
              },
              {
                name: 'beforeText',
                bindings: 'TextField',
                value: '',
              },
              {
                name: 'afterText',
                bindings: 'TextField',
                value: '',
              },
            ],
          };
        }),
      },
    ],
  },
];
export const settingsAndExportFormHelpers = {};
